import * as React from 'react';

export const CELL_SEP = <>&#x200b;</>;
export const INFINITE_SCROLL_DIRECTION_UP = 'UP';
export const INFINITE_SCROLL_DIRECTION_DOWN = 'DOWN';
